import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import Button from '@jetbrains/ring-ui/components/button/button';
import DropdownMenu from '@jetbrains/ring-ui/components/dropdown-menu/dropdown-menu';
import Icon from '@jetbrains/ring-ui/components/icon';
import chevronDown from '@jetbrains/icons/chevron-down';
import Tooltip from '@jetbrains/ring-ui/components/tooltip/tooltip';
import { IdpBannerDefaultContent } from '@modules/users/banners/idp-banner-default-content';
import HorizontalContainer from '@common/page-layout/horizontal-container';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import { useServerConfigContext } from '@common/server-config-context/server-config-context';
import { PopupType } from './popups/users-page-popups';
const DROPDOWN_OPTIONS = [
    PopupType.INVITATION_LINK,
    PopupType.CONFIGURATION_FILE,
    PopupType.MANUALL
].map(label => ({
    label,
    key: label
}));
export function UsersPageActions({ openPopup, canAssignProfile }) {
    const serverConfig = useServerConfigContext();
    const idpImportEnabled = serverConfig.hasIdpIntegration();
    const addUsersAnchor = useMemo(() => {
        const addUsersButton = (_jsxs(Button, { disabled: idpImportEnabled, ...assignTestId('create-new-user-dropdown'), children: ["Add users ", _jsx(Icon, { glyph: chevronDown })] }));
        return idpImportEnabled ? (_jsx(Tooltip, { title: _jsx(IdpBannerDefaultContent, {}), children: addUsersButton })) : (addUsersButton);
    }, [idpImportEnabled]);
    return (_jsxs(HorizontalContainer, { children: [_jsx(Button, { primary: true, onClick: () => openPopup(PopupType.ADD_PROFILE), disabled: !canAssignProfile, children: "Assign profile" }), _jsx(DropdownMenu, { anchor: addUsersAnchor, onSelect: ({ label }) => openPopup(label), data: DROPDOWN_OPTIONS })] }));
}
